<p class="debugMessage"><small>Account-Manage-organisations:</small></p>
<nav class="navbar navbar-expand-lg bg-body-tertiary alignRow" style="height: var(--navBar-Height);">
	<span style="font-weight: bold;">Sites</span>
	<span class="navbar-nav me-auto mb-2 mb-lg-0"></span>
	<app-filter-box (search)="applyFilterSites($event)" PlaceHolder="Filter Sites List" />
	<span class="app-icon app-icon--add siteAdmin-only-outline" mat-icon-button *ngIf="currentUser.AdminSite"
		(click)="AddOrganisation()" [matTooltip]="'Admin Only'"
		style="margin-right: var(--default-margin);"><mat-icon /></span>
</nav>
<mat-table matSort [dataSource]="displayedOrganisations">
	<ng-container matColumnDef="{{column}}" *ngFor="let column of organisationsTableColumns" [ngSwitch]="true">
		<ng-container *ngSwitchDefault>
			<mat-header-cell *matHeaderCellDef mat-sort-header>{{column}}</mat-header-cell>
			<mat-cell *matCellDef="let row"> {{row[column]}} </mat-cell>
		</ng-container>
		<ng-container *ngSwitchCase="column === 'Image'">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let row" (click)="viewImage(imagePathOrganisations() + row.Id + '?' + row.Modified)">
				<img src="{{imagePathOrganisations()}}{{row.Id}}?{{row.Modified}}"
					style="max-height: 50px;max-width: 100%;padding: 5px;"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
					[attr.x-contenttype]="'image/png'" />
			</mat-cell>
		</ng-container>
		<ng-container *ngSwitchCase="column === 'Edit'">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let row">
				<span class="alignRow gridHover" *ngIf="selectedAccount.Admin">
					<span class="app-icon app-icon--edit">
						<mat-icon [ngStyle]="{ 'color': selectedAccount.Admin ? 'black' : 'lightgray' }"
							(click)="selectedAccount.Admin ? editOrganisation(row) : null" />
					</span>
					<span class="app-icon app-icon--delete">
						<mat-icon
							[ngStyle]="{ 'color': selectedAccount.Admin ? 'var(--color-red)' : 'lightgray !important' }"
							(click)="selectedAccount.Admin ? deleteOrganisations(row) : null" />
					</span>
				</span>
			</mat-cell>
		</ng-container>
	</ng-container>
	<mat-header-row *matHeaderRowDef="organisationsTableColumns"></mat-header-row>
	<mat-row class="mat-row" *matRowDef="let row; columns: organisationsTableColumns" style="height: 50px;"></mat-row>
</mat-table>
<mat-paginator [pageSizeOptions]="[5, 10]"></mat-paginator>